<template>
  <div>
    <v-toolbar-title>
      {{title}}
      <v-btn color="warning" fab small class="elevation-2 align-center">
        <v-icon @click="newData">add</v-icon>
      </v-btn>
    </v-toolbar-title>
    <v-data-table
      :headers="headers"
      :items="items"
    >
      <v-toolbar text>
      </v-toolbar>
      <template v-slot:item="props">
        <tr>
          <td class="text-center" v-if="header.value !== 'actions'" v-for="(header, index) in headers" :key="index">
            <v-edit-dialog
              :return-value.sync="props.item[header.value]"
              lazy
              large
              persistent
              @save="props.item[header.value] !== '' ? save : ''"
              @open="email = props.item.email"
            >
              {{props.item[header.value]}}
              <template v-slot:input>
                <v-text-field
                  v-if="header.value !== 'email' && header.value !== 'phone'"
                  v-model="props.item[header.value]"
                  label="Edit"
                  :rules="requiredRule"
                  single-line
                  counter
                ></v-text-field>
                <v-text-field
                  v-if="header.value === 'email'"
                  v-model="props.item[header.value]"
                  :rules="emailRule">
                </v-text-field>
                <v-text-field
                  v-if="header.value === 'phone'"
                  v-model="props.item[header.value]"
                  :rules="phoneRule">
                </v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td style="text-align: center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="blue" @click="editRow(props.item)" v-on="on">
                  edit
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
                  delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog width="500px" v-model="listDialog" persistent>
      <v-form v-model="valid" ref="listForm">
        <v-card>
          <v-card-title v-if="title === 'Volume per region'">
            <h3> {{editedIndex > -1 ? 'Edit deliveries per region' : 'New deliveries per region'}} </h3>
          </v-card-title>
          <v-card-title v-else>
            <h3>{{editedIndex > -1 ? 'Edit contact' : 'New contact'}}</h3>
          </v-card-title>
          <v-divider color="#42a5f5"></v-divider>
          <v-container fluid grid-list-lg>
            <v-row>
              <v-col cols="12" md="6" style="max-width: 50%;" v-if="title === 'Volume per region'" v-for="(header, index) in headers" :key="header.value">
                <v-text-field
                  :label="header.text"
                  v-if="header.text === 'Volume'"
                  v-model="editedItem[header.value]"
                  :rules="requiredRule"
                ></v-text-field>
                <v-select
                  :label="header.text"
                  v-if="header.text === 'Regions'"
                  :items="regions"
                  item-text="name"
                  item-value="name"
                  v-model="editedItem[header.value]"
                  :rules="requiredRule"
                ></v-select>
              </v-col>
              <v-col v-else cols="12" md="3">
                <v-text-field
                  :label="header.text"
                  v-if="header.text === 'Name'"
                  v-model="editedItem[header.value]"
                  :rules="requiredRule"
                ></v-text-field>
                <v-text-field
                  :label="header.text"
                  v-if="header.text === 'Position'"
                  v-model="editedItem[header.value]"
                  :rules="requiredRule"
                ></v-text-field>
                <v-text-field
                  :label="header.text"
                  v-if="header.text === 'Email'"
                  v-model="editedItem[header.value]"
                  :rules="emailRule"
                ></v-text-field>
                <v-text-field
                  :label="header.text"
                  v-if="header.text === 'Phone'"
                  v-model="editedItem[header.value]"
                  :rules="phoneRule"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions class="justify-center">
              <v-btn text color="red" @click="closeListDialog">Cancel</v-btn>
              <v-btn text color="primary" @click="save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>


    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ATTENTION
        </v-card-title>
        <v-card-text>
          You are about to delete this line. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue darken-1">No</v-btn>
          <v-btn text @click="deleteContractor" color="red">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    // @vuese
    // Table for the contacts of the client in the client application (deprecated)
    // @group Applications
    export default {
        name: "FormTable",
        props: {
            // Headers of the table
            headers: Array,
            // Title of the table
            title: String,
            // Client Object
            client: Object,
            // Field of the client Object pointed as contacts
            model: String,
            regions: Array,
        },
        data() {
            return {
                editedIndex: -1,
                valid: false,
                listDialog: false,
                items: [],
                toBeDeleted: null,
                deleteDialog: false,
                editedItem: {},
                requiredRule: [
                    v => !!v || 'This field is required'
                ],
                phoneRule: [
                    v => !!v || 'Phone is required',
                    v => /^(\+\d{2}[ \-]{0,1}){0,1}(((\({0,1}[ \-]{0,1})0{0,1}\){0,1}[2|3|7|8]{1}\){0,1}[ \-]*(\d{4}[ \-]{0,1}\d{4}))|(1[ \-]{0,1}(300|800|900|902)[ \-]{0,1}((\d{6})|(\d{3}[ \-]{0,1}\d{3})))|(13[ \-]{0,1}([\d \-]{5})|((\({0,1}[ \-]{0,1})0{0,1}\){0,1}4{1}[\d \-]{8,10})))$/.test(v) || 'Phone must be valid'
                ],
                emailRule: [
                    v => !!v || 'This field is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                ],
            }
        },
        methods: {
            newData() {
                this.editedIndex = -1;
                this.editedItem = {};
                this.listDialog = true;
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            deleteContractor() {
                let index = this.items.indexOf(this.toBeDeleted);
                this.items.splice(index, 1);
                this.toBeDeleted = null;
                this.deleteDialog = false;
                this.$store.commit('displaySnackbar', 'Delete successful');
            },
            editRow(item) {
                this.editedItem = Object.assign({}, item);
                this.editedIndex = this.items.indexOf(item);
                this.listDialog = true;
            },
            closeListDialog() {
                this.editedIndex = -1;
                this.listDialog = false;
                this.editedItem = {};
            },
            save() {
                if (this.editedIndex > -1) {
                    Object.assign(this.items[this.editedIndex], this.editedItem);
                    this.$store.commit('displaySnackbar', 'Edit successful');
                } else {
                    if (this.$refs.listForm.validate()) {
                        this.items.push(this.editedItem);
                    }
                }
                this.listDialog = false;
            },
        },
        mounted() {
            this.items = this.client[this.model];
        }
    }
</script>

<style scoped>
  .v-small-dialog >>> .v-menu__activator {
    height:100%;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/util/CreateClient/FormTable.vue